var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.showText)?_c('v-chip',{staticClass:"construct-visual-badge",attrs:{"color":_vm.color,"small":_vm.item.small,"outlined":_vm.item.outlined}},[_vm._v(" "+_vm._s(_vm.truncateText(_vm.text))+" ")]):_c('v-icon',{attrs:{"color":_vm.color,"small":_vm.item.small,"title":"Pastille"}},[_vm._v("mdi-circle")])
}
var staticRenderFns = []

export { render, staticRenderFns }